import {
  Dimensions,
  Platform, 
} from 'react-native';
import ff from './ff';

//global.t = null; // current component, replaced at cf.myRN_stt, cleared at cf.myNV_stt_move

export default class cc { // individual constant
  //
  static g_os = 
    (Platform.OS == 'android') ? 'a'
    : (Platform.OS == 'ios') ? 'i'
    : (Platform.OS == 'web') ? 'w'
    : ''
  ;
  //
  static g_app_name = 'mqcs';
  static g_app_type = ['w']; // w: web, i:ios, a:android
  //
  static g_ver = '1.0.0';

  static gb_dbg = true; // 開発環境
  //
  static gb_dev = false; // 本番環境
  //    
  static g_url0 = ''; 
  static g_url1 = ''; // for db nginx の conf を変更要
  static g_url2 = ''; // for file

  static g_srt_key = ''; // secret key


  static gn_w = Dimensions.get('window').width - 2; // windows の web において horizontal scroll bar を表示しないために -2 が必要
  static gn_h = Dimensions.get('window').height;

  static gn_btnWLrg = 120; // button width large
  static gn_btnWNrm = 90; // button width normal
  static gn_btnWSml = 60; // button width small

  static gn_maxBdyW = 1024; // ipad pro 12.9
  static gn_minBdyW = 375; // iphone 6

//  static gn_bdyW = cc.gn_w;
  static gn_bdyW = (cc.gn_w > cc.gn_maxBdyW) ? cc.gn_maxBdyW : cc.gn_w;

  static gn_mgnLrg = 8; // margin large
  static gn_mgnNrm = 4; // margin normal
  static gn_mgnSml = 2; // margin small

//  static gn_mdlH = cc.gn_h - cc.gn_mgnNrm * 2;  
//  static gn_mdlW = ((cc.gn_bdyW > 660 ) ? 660 : cc.gn_bdyW) - cc.gn_mgnNrm * 2;

  static gn_iconSizeLrg = 40; // ison size large
  static gn_iconSizeNrm = 30; // ison size normal
  static gn_iconSizeSml = 20; // ison size small

  static gn_bdrWFat = 4; // border width fat
  static gn_bdrWNrm = 2; // border width normal
  static gn_bdrWNrw = 1; // border width narrow

  static gn_hdrBarH = (cc.g_os == 'i' && ic.gn_h >= 800) ? 30 : 0; // g_app_type が i を含む場合
  static gn_ftrBarH = (cc.g_os == 'i' && ic.gn_h >= 800) ? 10 : 0; // g_app_type が i を含む場合

  static gn_hdrH = cc.gn_iconSizeLrg + cc.gn_mgnNrm * 2 + cc.gn_hdrBarH; // hdr height
  static gn_ftrH = 0; // 廃止予定

  static gn_bdyH = cc.gn_h - (cc.gn_hdrH + cc.gn_ftrH);

  static gn_bdyX = 0;

  static gn_hdrY = 0;
  static gn_bdyY = cc.gn_hdrH;
//  static gn_ftrY = cc.gn_hdrH + cc.gn_bdyH; // border は component の外側としてカウントされる


  static gn_chbW = 20; // checkbox width
  static gn_arwW = 30; // arrow width
  static gn_scbW = 16; // scroll bar width
      
  static gn_bdrRdsLrg = 12; // border radius large
  static gn_bdrRdsNrm = 6; // border radius normal
  static gn_bdrRdsSml = 3; // border radius small

  static gn_fontSizeLrg = 16; // font size large
  static gn_fontSizeNrm = 14; // font size normal
  static gn_fontSizeSml = 12; // font size small

  static gn_btnIconSize = cc.gn_fontSizeSml + cc.gn_mgnNrm * 2; // size of button icon
  
  // zIndex
  static gn_zIdxBdy  = 10; // for Bdy
  static gn_zIdxFtr  = 20; // for Ftr
  static gn_zIdxHdr  = 30; // for Hdr
  static gn_zIdxMdl  = 60; // for Mdl
  static gn_zIdxPck  = 80; // for Pck
  static gn_zIdxLdr  = 90; // for Ldr

  static g_fontCcdLrg = '#2d3142'; // font ccd large
  static g_fontCcdNrm = '#4d5162'; // font ccd normal
  static g_fontCcdSml = '#5d6172'; // font ccd small

  static g_ccdKN = '#222222'; // black normal
  static g_ccdKP = '#595857'; // black pale
  static g_ccdHN = '#80989b'; // glay
  static g_ccdHP = '#c0c6c9'; // glay
  static g_ccdBP = '#deb068'; // brown
  static g_ccdPP = '#f6bfbc'; // pink
  static g_ccdMP = '#dbd0e6'; // purple
  static g_ccdAN = '#007bbb'; // Blue
  static g_ccdAP = '#89c3eb'; // Blue
  static g_ccdCN = '#00acc1'; // cyan
  static g_ccdCP = '#a0d8ef'; // cyan
  static g_ccdGP = '#d0e8d2'; // green
  static g_ccdYP = '#f5e56b'; // yellow
  static g_ccdON = '#f39800'; // orange
  static g_ccdOP = '#f7b977'; // orange
  static g_ccdRN = '#c40000'; // red
  static g_ccdRP = '#f2a0a1'; // red
  static g_ccdWN = '#fffffc'; // white

  static gdd_ccdDefss = {
    own1:{
      hdrCcd: '#c40000',
      ftrCcd: '#c40000',
      bdyCcd: '#c40000',
    },
    cmn:{
      hdrCcd: '#c40000',
      ftrCcd: '#c40000',
      bdyCcd: '#c40000',
    },
  };

  static g_backCcd = cc.g_ccdWN;
  static g_baseCcd = '#f0f0f0';
  static g_bdrCcd = '#bbbbbb'; // border color code

  static gd_stss1 = { // persisted state variable, myRN_stt にも加える必要あり
    //
    sgc_cm10_key: '', // app user key
    sgc_cm10c210: '', // app user name
    sgc_cm10t110: '', // app user privilidge
    //
    sgc_user_key: '',
    sgc_user_img: '',
    sgc_eml: '',
    sgc_nmb: '',
    sgc_tkn: '',
    //
    sgc_pageRole: cc.g_iniPageRole,
    sgc_pageName: cc.g_iniPageName,
    sgcd_pagePntKeys: {
      cm10_key: '',
      cm20_key: '',
    },
    sgc_pageKey: '',
    sgc_pageMode: '', // show / new /edit
    sgc_pagePrc: '',
    sgcb_pageEdt: false,
    //
    sgcd_pageCmns: {},    
    sgcd_pageStgs: {},
  };

  static gd_stss2 = { // not persisted state variable
    //
    sgcb_showLdr: false, // loader
    //
    sgcn_bdyY: cc.gn_bdyY, // body position y
    sgcd_inpMsrs: {}, // current input measures y
    sgcn_btmH: 0, // bottom height
    sgcn_adjY: 0, // adjust keyboard slide
    //
    sgcd_items: {}, // commonly used item hdr / bdy / btm / ftr 間で情報を共有するために使用
    //
    sgcd_mdls: { // 使用するパラメータを事前に定義しないとエラーが発生
      pck: { // mdlType
        b_showMdl: false,
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
      },
      file: { // mdlType
        b_showMdl: false,
        mode: 'text/csv',
        onRead: null, // callback on read
      },
      menu: { // mdlType
        b_showMdl: false,
        ld_iss: [{
          pfx:'',
          onPrs: null,
        }],
      },
      msg: { // mdlType
        b_showMdl: false,
      },
      pckFiles: { // mdlType
        b_showMdl: false,
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
      },
      pckSch: { // mdlType
        b_showMdl: false,
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
        d_tmps: {},
      },
      pckDate: { // mdlType
        b_showMdl: false,
        b_clr: true,
        ld_iss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
        dop_acts: {
          updLists: _s => null,
        },
      },
      rtc: { // mdlType
        b_showMdl: false,
      },
      pckSlc: { // mdlType
        b_showMdl: false,
        ld_itemss: [],
        id: '',
        d_slcItems: {
          key:'', 
          pfx:'',
          b_new: false,
        },
      },
      cfm: {
        b_showMdl: false,
        msg: '',
        ld_btnss: [
        ],
      },
      srp: {
        b_showMdl: false,
        name: '',
        amt: '0', // amount > 50
        id: '', // transaction id
        plcKey: '',
        onScd: () => null,
      },
      etc: { // mdlType
        b_showMdl: false,
        b_hideMdl: false,
      },
    },
    sgcd_hdrs: {
      pfx: '',
      d_leftBtns: {
        b_vsb: false,
        iconName: null,
        pfx: null,
        onPrs: null,
      },
    },
    sgcd_bdys: {
        ld_defss: [],
    },

    sgcn_tab: 1,

    sgcb_srlToEnd: false,

    sgcdld_cm31sss: null,

    sgc_pnlMode: 'list',
    sgc_pnlPhs: 'ini',

    sgcd_schs: { // for search
    },

    sgcn_step: 0,
    
    sgcd_prss: {
      n_wgt: 100,
      n_crrCnt: 0,
      n_ttlCnt: 0,
    }, // progress

    sgcd_menuDefss: null,

    sgcd_dmns: { // dimensions set at myRN_stt
      n_w: cc.gn_w, 
      n_h: cc.gn_h,
      n_bdyW: cc.gn_bdyW,
      n_bdyH: cc.gn_bdyH,
    }, 

    sgcd_crls: { // controles
      b_prt: false,
    },

  }

  static gn_iniItemCnt = 10; // initial Item count

  static gn_logoH = 60; // ロゴサイズに合わせて調整
  static gn_logoW = 60; // ロゴサイズに合わせて調整

  static gld_yesNo = [
    {
      key:'1',
      pfx:'はい'
    },
    {
      key:'0',
      pfx:'いいえ'
    },
  ];

  ////////////////////////////////////////////////////////////////////////
  static dlm = '_';
  static minDtm = '1900-01-01 00:00:00'; // date time min
  static maxDtm = '9999-12-31 00:00:00'; // date time max
  static maxNmb = Number.MAX_SAFE_INTEGER;

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */

